/* eslint-disable react/no-unescaped-entities */
import React, { useContext } from 'react';
import { Container, Typography } from '@pwskills/rachnaui';
import Slider from '@pwskills/rachnaui/components/Slider';
import Headers from '@/components/common/Header';
import CourseDescriptionContext from '@/context/CourseDescriptionContext';
import { useRouter } from 'next/router';
import Testimonial from './Testimonial';
import ProfessionalThemeHeader from '../../Header/ProfessionalThemeHeader';

const AlumniTestimonialTileType = ({ isAmateur = true }: { isAmateur?: boolean }) => {
  const { courseDetails } = useContext(CourseDescriptionContext);
  const { testimonials } = courseDetails?.courseMetaDetails || {};
  const router = useRouter();
  const isDashboard = router.pathname.includes('/dashboard');
  if (!testimonials?.length) return null;

  // to show 4 items in mobile ui
  const chunkedCourseOffering = [] as any;
  for (let i = 0; i < testimonials.length; i += 6) {
    chunkedCourseOffering.push(testimonials.slice(i, i + 6));
  }
  const returnChildren = () => {
    return (
      <>
        {isDashboard && (
          <Typography component="h4" variant="semi-bold">
            Alumni's Testimonies
          </Typography>
        )}
        {isAmateur && !isDashboard && (
          <header className="flex justify-center text-[#3D3D3D]">
            <Headers
              title="Alumni's Testimonies"
              classes="flex !min-w-full w-full justify-center text-gray-850 medium:w-auto text-center !self-center !w-[50%]  medium:!w-full"
            />
          </header>
        )}
        {!isAmateur && !isDashboard && (
          <ProfessionalThemeHeader
            title="Champions of Change: Alumni Experiences"
            subtitle="Unlock the potential within our alumni's experiences and witness the transformative power of upscaling on their careers and lives"
          />
        )}

        <div className="hidden large:!flex">
          <Slider
            iconWrapperClass="!p-0"
            wrapperClass="flex flex-col gap-6"
            positionOfSliderInMobile="bottom"
          >
            {chunkedCourseOffering?.map(
              (
                chunk: {
                  testimonialType: string;
                  name: string;
                  description: string;
                  designation: string;
                  testimonialImage: string;
                  videoLink?: string;
                  _id?: string;
                }[]
              ) => (
                <div className="relative !w-[100%]  !shrink-0 flex flex-wrap gap-6 justify-center">
                  {chunk?.map(
                    ({
                      _id,
                      testimonialType,
                      videoLink,
                      description,
                      testimonialImage,
                      name,
                      designation,
                    }) => (
                      <Testimonial
                        testimonialType={testimonialType}
                        description={description}
                        videoLink={videoLink || ''}
                        name={name}
                        designation={designation}
                        testimonialImage={testimonialImage || ''}
                        key={_id}
                      />
                    )
                  )}
                </div>
              )
            )}
          </Slider>
        </div>

        <div className="large:!hidden">
          <Slider
            className="!gap-4"
            wrapperClass="flex flex-col gap-6"
            iconWrapperClass="!p-0"
            positionOfSliderInMobile="bottom"
          >
            {testimonials?.map(
              ({
                _id,
                testimonialType,
                videoLink,
                description,
                testimonialImage,
                name,
                designation,
              }) => (
                <Testimonial
                  testimonialType={testimonialType}
                  description={description}
                  videoLink={videoLink || ''}
                  name={name}
                  designation={designation}
                  testimonialImage={testimonialImage || ''}
                  key={_id}
                />
              )
            )}
          </Slider>
        </div>
      </>
    );
  };
  return (
    <div>
      {testimonials && testimonials?.length > 0 && (
        <section
          data-title="Testimonial"
          id="testimonial"
          className={isDashboard ? '' : 'bg-gradient-to-b  from-white to-[#F9F9F9]'}
        >
          {isDashboard ? (
            <div className="p-4 gap-4 flex flex-col">{returnChildren()}</div>
          ) : (
            <Container className="py-8 large:!py-14">{returnChildren()}</Container>
          )}
        </section>
      )}
    </div>
  );
};

export default AlumniTestimonialTileType;
